import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IPlaceGenralInformationForm } from 'features/Places/types'
import { GTTPlaceVertical } from 'gql/types.generated'
import { isCompanyRequired } from 'features/Places/utils'

const nameMessages = defineMessages({
  required: {
    id: 'places.new.form.name.required',
    defaultMessage: 'The name is required'
  },
  max: {
    id: 'places.new.form.name.max',
    defaultMessage: 'The name can be up to 255 characters'
  }
})

const paramMessages = defineMessages({
  required: {
    id: 'places.new.form.param.required',
    defaultMessage: 'The param is required'
  },
  max: {
    id: 'places.new.form.param.max',
    defaultMessage: 'The param can be up to 255 characters'
  }
})

const codeMessages = defineMessages({
  required: {
    id: 'places.new.form.code.required',
    defaultMessage: 'The code is required'
  },
  max: {
    id: 'places.new.form.code.max',
    defaultMessage: 'The code can be up to {max} characters'
  }
})

const typeMessages = defineMessages({
  required: {
    id: 'places.new.form.type.required',
    defaultMessage: 'The place type is required'
  }
})

const verticalMessages = defineMessages({
  required: {
    id: 'places.new.form.vertical.required',
    defaultMessage: 'The vertical is required'
  }
})

const companyMessages = defineMessages({
  required: {
    id: 'places.new.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const businessClientMessages = defineMessages({
  required: {
    id: 'places.new.form.businessClient.required',
    defaultMessage: 'The business client is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IPlaceGenralInformationForm> => {
  return yup.object().shape({
    name: yup
      .string()
      .required(intl.formatMessage(nameMessages.required))
      .max(255, intl.formatMessage(nameMessages.max)),
    param: yup
      .string()
      .required(intl.formatMessage(paramMessages.required))
      .max(255, intl.formatMessage(paramMessages.max)),
    code: yup
      .string()
      .required(intl.formatMessage(codeMessages.required))
      .max(10, ({ max }) => intl.formatMessage(codeMessages.max, { max })),
    type: yup.mixed().required(intl.formatMessage(typeMessages.required)),
    area: yup.string().optional(),
    tags: yup.array().of(yup.string().required()),
    amenities: yup.array().of(yup.object().shape({ id: yup.string().required(), label: yup.string().required() })),
    company: yup
      .object()
      .shape({ id: yup.string(), name: yup.mixed(), vertical: yup.mixed() })
      .when('vertical', {
        is: (vertical: GTTPlaceVertical) => isCompanyRequired(vertical),
        then: yup.object().shape({
          id: yup.string().required(intl.formatMessage(companyMessages.required)),
          name: yup.mixed(),
          vertical: yup.mixed()
        }),
        otherwise: yup.object().optional()
      }),
    businessClient: yup
      .object()
      .shape({ id: yup.string(), name: yup.mixed() })
      .when('vertical', {
        is: (vertical: GTTPlaceVertical) => isCompanyRequired(vertical),
        then: yup
          .object()
          .shape({ id: yup.string().required(intl.formatMessage(businessClientMessages.required)), name: yup.mixed() }),
        otherwise: yup.object().optional()
      }),
    businessSite: yup.object().shape({ id: yup.string(), name: yup.mixed() }).optional(),
    vertical: yup.mixed().required(intl.formatMessage(verticalMessages.required))
  })
}
